
import { Component, Mixins } from "vue-property-decorator";
import { default as ForegroundDrawableObjectMixin } from "./ForegroundDrawableObjectMixin.vue";
import { default as ShapeDrawableMixin } from "./ShapeDrawableMixin.vue";
import { default as DraggableMixin } from "./DraggableMixin.vue";

@Component
export default class DraggableShapeDrawableObjectMixin extends Mixins(
  ForegroundDrawableObjectMixin,
  ShapeDrawableMixin,
  DraggableMixin
) {
}
